import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import {
  FiCatalogResponse,
  FiRecordEntity,
  FiRecordInsightsResponse,
} from "@mapmycustomers/shared/types/entity/fieldInsight";
import { AnyEntityId } from "@mapmycustomers/shared/types/entity/types";

export const fetchRecordCharts = createAsyncAction(
  "@component/recordCharts/fetchRecordCharts/request",
  "@component/recordCharts/fetchRecordCharts/success",
  "@component/recordCharts/fetchRecordCharts/failure"
)<{ entityType: FiRecordEntity; recordId: AnyEntityId }, FiRecordInsightsResponse, unknown>();

// In the store because the chip that opens a chart and the panel that draws it are siblings.
export const openRecordChart = createAction("@component/recordCharts/openRecordChart")<
  FiCatalogResponse["id"]
>();

export const closeRecordChart = createAction("@component/recordCharts/closeRecordChart")();

export type Actions = ActionType<
  typeof closeRecordChart | typeof fetchRecordCharts | typeof openRecordChart
>;
